import React, { useState, useRef } from 'react';
import { storageApi } from '../utils/api';

interface Props {
  onSearch: (results: any[]) => void;
}

const SearchForm: React.FC<Props> = ({ onSearch }) => {
  const [loading, setLoading] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(e.currentTarget);
    let noValue = formData.get('no') as string;
    if (noValue) {
      noValue = parseInt(noValue, 10).toString();
    }
    const searchParams = {
      musteri: formData.get('musteri') as string,
      plaka: formData.get('plaka') as string,
      no: noValue,
      baslangicTarihi: formData.get('baslangicTarihi') as string,
      bitisTarihi: formData.get('bitisTarihi') as string
    };

    try {
      const response = await storageApi.search(searchParams);
      if (response.data?.data) {
        onSearch(response.data.data);
      }
    } catch (error) {
      console.error('Arama hatası:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    if (formRef.current) {
      formRef.current.reset();
      onSearch([]); // Aramaları temizle
    }
  };

  return (
    <form ref={formRef} onSubmit={handleSubmit} className="search-form">
      <div className="form-row" style={{ 
        display: 'flex', 
        justifyContent: 'space-between',
        gap: '30px', 
        marginBottom: '12px',
        width: '100%'
      }}>
        <div className="form-group" style={{ flex: '1', maxWidth: '200px', minWidth: '180px' }}>
          <label htmlFor="musteri">Müşteri</label>
          <input type="text" id="musteri" name="musteri" className="form-control form-control-sm" />
        </div>
        <div className="form-group" style={{ flex: '1', maxWidth: '200px', minWidth: '180px' }}>
          <label htmlFor="plaka">Plaka</label>
          <input type="text" id="plaka" name="plaka" className="form-control form-control-sm" />
        </div>
        <div className="form-group" style={{ flex: '1', maxWidth: '200px', minWidth: '180px' }}>
          <label htmlFor="no">No</label>
          <input type="text" id="no" name="no" className="form-control form-control-sm" />
        </div>
        <div className="form-group" style={{ flex: '1', maxWidth: '200px', minWidth: '180px' }}>
          <label htmlFor="baslangicTarihi">Başlangıç</label>
          <input type="date" id="baslangicTarihi" name="baslangicTarihi" className="form-control form-control-sm" />
        </div>
        <div className="form-group" style={{ flex: '1', maxWidth: '200px', minWidth: '180px' }}>
          <label htmlFor="bitisTarihi">Bitiş</label>
          <input type="date" id="bitisTarihi" name="bitisTarihi" className="form-control form-control-sm" />
        </div>
      </div>

      <div className="button-row" style={{ 
        display: 'flex', 
        justifyContent: 'center',
        gap: '12px',
        marginTop: '12px'
      }}>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Aranıyor...' : 'Ara'}
        </button>
        <button type="button" className="btn btn-secondary" onClick={handleReset}>
          Temizle
        </button>
      </div>
    </form>
  );
};

export default SearchForm; 